import React from 'react'
import { ratingIcons } from 'keys/rating'
import { tierDescriptions } from '../constants'

// רוחב מינימלי כדי שמקטע קטן לא ייעלם
const clampedPct = (tier) => Math.max(tier.percentage, 6)

// רוחבי שני האגפים (קוראים/מתקשים) באחוזים — הירוק מקיף גבוה+מצופה+חצי מהמקטע הצהוב,
// האדום את החצי השני+נמוך+נמוך מאוד. משמש גם את החיצים וגם את כרטיסי האחוזים שמעליהם,
// כדי שיישארו מיושרים זה לזה (כמו בפיגמה)
export const splitWidths = (tiers) => ({
    readers: clampedPct(tiers[0]) + clampedPct(tiers[1]) + clampedPct(tiers[2]) / 2,
    struggling: clampedPct(tiers[2]) / 2 + clampedPct(tiers[3]) + clampedPct(tiers[4]),
})

// חיצים SVG תואם פיגמה
const BracketArrow = ({ className }) => (
    <svg className={className} viewBox="0 0 8 5" width="8" height="5" fill="none">
        <path d="M1 1L4 4L7 1" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

// גרף התפלגות (עיצוב פיגמה) — 5 בלוקים צבעוניים בגובה קבוע, רוחב לפי אחוזים, גבוה מימין.
// בתוך כל בלוק: אחוז, כמות תלמידים ותגית דירוג; התיאור מוצג מתחת לבלוק
const DistributionBar = ({ tiers, onTierClick, showDescriptions = true, showBrackets = false, blurred = false }) => {
    if (!tiers?.length) return null

    const width = (tier) => `${clampedPct(tier)}%`

    const { readers: readersWidth, struggling: strugglingWidth } = splitWidths(tiers)

    return (
        <div>
            {showBrackets &&
                <div className='distribution-brackets'>
                    <div className='distribution-bracket' style={{ width: `${readersWidth}%`, color: '#7FAE1A' }}>
                        <BracketArrow className='bracket-arrow bracket-arrow-right' />
                        <BracketArrow className='bracket-arrow bracket-arrow-left' />
                    </div>
                    <div className='distribution-bracket' style={{ width: `${strugglingWidth}%`, color: '#FF4D4D' }}>
                        <BracketArrow className='bracket-arrow bracket-arrow-right' />
                        <BracketArrow className='bracket-arrow bracket-arrow-left' />
                    </div>
                </div>}
            <div className='distribution-blocks'>
                {tiers.map(tier => (
                    <div
                        key={tier.index}
                        className='distribution-block'
                        style={{ width: width(tier), backgroundColor: tier.color, color: tier.textColor, cursor: onTierClick ? 'pointer' : 'default' }}
                        onClick={onTierClick ? () => onTierClick(tier) : undefined}
                        title={`${tier.count} תלמידים (${tier.percentage}%)`}
                    >
                        <div className='block-pct'>{`${tier.percentage}%`}</div>
                        <div className={`block-count`}><span className={`${blurred && 'blurred2'}`}>{tier.count.toLocaleString()}</span>{' תלמידים'}</div>
                        <div className='tier-chip' style={{ backgroundColor: tier.labelBg, color: tier.textColor }}>
                            <i className={ratingIcons[tier.index - 1]} />
                            {tier.label}
                        </div>
                    </div>
                ))}
            </div>
            {showDescriptions &&
                <div className='distribution-labels'>
                    {tiers.map(tier => (
                        <div key={tier.index} className='distribution-label-item' style={{ width: width(tier), flexGrow: 1 }}>
                            <div className='tier-description'>{tierDescriptions[tier.index - 1]}</div>
                        </div>
                    ))}
                </div>}
        </div>
    )
}

export default DistributionBar
